<template>
  <div id="app">
    <!-- --><router-view />
    <!-- <index :value="100"  :title="'车速'" :width="200" :type="'consumptionPer100km_eng'" :showInCenter="true" /> -->
  </div>
</template>
<script>
// import index from "@/views/vmonitor/speedlimit/index.vue" //限速控制
// import index from "@/views/vmonitor/speedlimit/hightlimit.vue" //最高限速控制
// import index from "@/views/vmonitor/speedlimit/arealimit.vue" //区域限速
// import index from "@/views/vmonitor/speedlimit/time_speed_set.vue" //夜间限速
// import index from "@/views/vmonitor/speedlimit/tired_limit_speed_set.vue" //疲劳驾驶限速
// import index from "@/views/vmonitor/VehiclePhotoMgr/VehiclePhotoCapture.vue" //图片抓拍
// import index from "@/views/vmonitor/VedioMonitor/VedioMonitorMgr.vue" //视频监控
// import index from "@/views/statistics/operationalData/index.vue" //运行数据
// import index from "@/views/driver/drivingScores/index.vue" //驾驶评分
// import index from "@/views/statistics/chronology/index.vue" //工作年表
// import index from "@/views/maintenance/transactionReminder/index.vue" //事务提醒
// import index from "@/views/maintenance/upkeep/index.vue" //保养登记
// import index from "@/views/maintenance/yearlyOrQuarter/index.vue" //运营证年检/季检登记
// import index from "@/views/maintenance/annualInspection/index.vue" //年检登记
// import index from "@/views/login/index.vue" //
// import index from "@/components/KLVehicleSelect" //
// import index from "@/views/demo/map" //
import index from "@/views/demo/pdf" //
// import index from "@/components/KLGauge" //

// import index from "@/views/statistics/vehicleReport/index" //
// import index from "@/components/KLVideo/index" //
// import index from "@/components/KLVideo/VideoPlay"; //

// import index from "@/views/vmonitor/locateVehicle/VehicleDashboard" //

// import index from "@/views/demo/tree" //
// import index from "@/views/statistics/socchange/index" //

// import index from "@/views/statistics/speedcharts/index" //

// import index from "@/views/basicmanagement/driverManagement/index.vue"
// import index from "@/views/maintenancemanagement/accidentManagement/index.vue"
// import {bd09togcj02,gcj02tobd09,wgs84togcj02} from "@/utils/lnglat"
// import mqtt from 'mqtt'

// const options = {
//       connectTimeout: 4000, // 超时时间
//       // 认证信息
//       clientId: 'mqttx_1001968',
//       username: '',
//       password: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJPcGVyYXRvcklEIjoiMjY4NDM1ODg5IiwiQ29tcGFueUlEIjoiXHUwMDNjbmlsXHUwMDNlIiwiT3B0TmFtZSI6IjEwMDE5NjgiLCJDb21OYW1lIjoi6L2m6IGU572R56CU5Y-R6YOoIiwiUGVybWlzc2lvbnMiOm51bGwsImV4cCI6MTc3MTE0MjkwMiwiaXNzIjoibG9uZ3lpIiwibmJmIjoxNzY4NTUwOTAyfQ.VcxHCm6cSWh9axsrh2kJyyvyROlBp5ajTqxZtCyJHxY',
// }

// const client = mqtt.connect('ws://127.0.0.1:8083/mqtt', options)

// client.on('reconnect', (error) => {
//     console.log('正在重连:', error)
// })

// client.on('error', (error) => {
//     console.log('连接失败:', error)
// })
// client.on('connect', (e) => {
//     console.log('成功连接服务器')
//     client.subscribe('test/topic', (err) => {
//         if (!err) {
//             console.log('成功订阅主题')
//         }
//     })
//     client.publish('test/topic', 'hello mqtt')
//     client.on('message', (topic, message) => {
//         console.log('收到消息:', topic, message.toString())
//     })
  
// })


export default {
  components: {
    index,
  },
  data() {
    return {
      videoPlayer: {
        videoId: "sdfsdf",
        canvasId: "sdfsdf11",
        // src: "https://www.kingwings.cn:7205/live/00140401000001.live.flv",
        src: "https://replay3.kingwings.cn/live/004011000368-1",
        setPromptWord(key) {
          console.log("设置提示词", key);
        },
        VideoPlay: {
          destroy() {
            console.log("destroy");
          },
        },
      },
    };
  },
  mounted() {
    // console.log(wgs84togcj02(117.983248,24.591644))
    // this.$refs.index.load();
  },
};
</script>
<style>
* {
  margin: 0;
  padding: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
</style>
